const copyForOldBrowsers = (value: string): Promise<void> =>
  new Promise((resolve, reject) => {
    const textArea = document.createElement('textarea');

    textArea.style.position = 'absolute';
    textArea.style.top = '0';
    textArea.style.left = '-9999px';

    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = '0';
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';

    // Avoid flash of the white box if rendered for any reason.
    textArea.style.background = 'transparent';

    textArea.value = value;

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        resolve();
      } else {
        reject(new Error('Oops, unable to copy'));
      }
    } catch (error) {
      reject(error);
    }

    document.body.removeChild(textArea);
  });

export const copyToClipboard = (value: string): Promise<void> => {
  return (navigator?.clipboard?.writeText ? navigator.clipboard.writeText(value) : Promise.reject()).catch(() =>
    copyForOldBrowsers(value)
  );
};
